import React, { FunctionComponent } from "react";
import { Link } from "react-router";

import { MenuIcon } from "./icons";
import { WebtieWordmark } from "../WebtieWordmark";

interface Props {
  userId: string;
  onOpenMenu: () => void;
}

/** Kopfleiste nur auf Mobile: öffnet die Sidebar als einschiebbares Menü. */
export const MobileBar: FunctionComponent<Props> = ({ userId, onOpenMenu }) => (
  <div className="app-mobilebar">
    <button type="button" className="btn btn-icon app-mobilebar__toggle" aria-label="Menü öffnen" onClick={onOpenMenu}>
      <MenuIcon size={18} />
    </button>
    <Link to={`/user/${userId}/dashboard`} className="app-mobilebar__brand" aria-label="webtie Startseite">
      <WebtieWordmark size={20} />
    </Link>
  </div>
);
